import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon as IGlobal } from './types.ts';

export interface IIcon extends IGlobal {
  sort?: 'ASC' | 'DESC' | undefined;
  secondaryColor?: string;
}

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon(
  { sort, size = 24, alt, color, secondaryColor, className, onClick },
  ref,
) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  const secondaryFillColor = secondaryColor || theme.colors.grey70_1;
  return (
    <svg ref={ref} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className} onClick={onClick}>
      <path
        d='M15.1414 16.1527V9.39355H13.2358V16.1527H10.3772L14.1886 20L18 16.1527H15.1414Z'
        fill={(sort === 'ASC' && secondaryFillColor) || (sort === 'DESC' && fillColor) || secondaryFillColor}
      />
      <path
        d='M9.81141 4L6 7.84723H8.85857V14.6064H10.7642V7.84723H13.6228L9.81141 4Z'
        fill={(sort === 'ASC' && fillColor) || (sort === 'DESC' && secondaryFillColor) || secondaryFillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
